import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    ConfigurationIncidentsSeveritiesLaboratoriesCreateRequest,
    ConfigurationIncidentsSeveritiesLaboratoriesPatchInBatchRequest,
    ConfigurationIncidentsSeveritiesLaboratoriesResponse
} from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities-laboratories.dto'

class IncidentsSeveritiesLaboratoriesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationIncidentsSeveritiesLaboratoriesResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationIncidentsSeveritiesLaboratoriesResponse>>(`/configuration/laboratories/${laboratoryId}/incidentSeverityLaboratories`, filterModel, { params })
        return response.data
    }

    async getIncidentsSeveritiesLaboratoryById(laboratoryId: number, incidentsSeveritiesLaboratoryId: number): Promise<ConfigurationIncidentsSeveritiesLaboratoriesResponse> {
        const response = await axios.get<ConfigurationIncidentsSeveritiesLaboratoriesResponse>(`/configuration/laboratories/${laboratoryId}/incidentSeverityLaboratories/${incidentsSeveritiesLaboratoryId}`)
        return response.data
    }

    async createIncidentsSeveritiesLaboratory(laboratoryId: number, request: ConfigurationIncidentsSeveritiesLaboratoriesCreateRequest): Promise<ConfigurationIncidentsSeveritiesLaboratoriesResponse> {
        const response = await axios.post<ConfigurationIncidentsSeveritiesLaboratoriesResponse>(`/configuration/laboratories/${laboratoryId}/incidentSeverityLaboratories`, request)
        return response.data
    }

    async deleteIncidentsSeveritiesLaboratory(laboratoryId: number, incidentsSeveritiesLaboratoryIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/incidentSeverityLaboratories/batch`, { data: incidentsSeveritiesLaboratoryIds })
        return response.data
    }

    async patchIncidentsSeveritiesLaboratory(laboratoryId: number, requests: ConfigurationIncidentsSeveritiesLaboratoriesPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/incidentSeverityLaboratories/batch`, requests)
        return response.data
    }
}

export const incidentsSeveritiesLaboratoriesConfigurationServices = new IncidentsSeveritiesLaboratoriesConfigurationServices()
